import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

const plyr = {
    playerInstances: [],
    init() {
        const players = document.querySelectorAll('.js-player');
        players.forEach((player) => {
            this.playerInstances.push(new Plyr(player));
        });

        return this.playerInstances;
    }
};

export default plyr;
